import * as actionTypes from '../Action/SnackbarAction';

const initialState = {
    action: false,
    open: false,
    message: 'Note archived',
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
    },
    variant: 'default',
    alertSeverity: 'success',
    transition: 'Fade',
    close: true,
    actionButton: false
};

const snackbarReducer = (state = initialState, action:actionTypes.SNACKBARActionTypes) => {
    switch (action.type) {
        case actionTypes.SNACKBAR_OPEN:             
            return {
                ...state,
                action: !state.action,
                open: action.Data.open ? action.Data.open : initialState.open,
                message: action.Data.message ? action.Data.message : initialState.message,
                anchorOrigin: action.Data.anchorOrigin ? action.Data.anchorOrigin : initialState.anchorOrigin,
                variant: action.Data.variant ? action.Data.variant : initialState.variant,
                alertSeverity: action.Data.alertSeverity ? action.Data.alertSeverity : initialState.alertSeverity,
                transition: action.Data.transition ? action.Data.transition : initialState.transition,
                close: action.Data.close === false ? action.Data.close : initialState.close,
                actionButton: action.Data.actionButton ? action.Data.actionButton : initialState.actionButton
            };
        default:
            return state;
    }
};

export default snackbarReducer;
